import React from 'react';
import Routes from './routes'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './actions/auth';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
  palette: {
    primary: blue
  },
})


function App({signOutUser}) {



    return (
      <ThemeProvider theme={theme}>
                      <Routes/>
      </ThemeProvider>
    );
}

const mapStateToProps = state => state.auth;

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(App)
